import { AxiosResponse } from 'axios';
import { authenticatedPostRequest } from './authenticatedRequestService';
import { IRequestConsultPatientCRMPatientCare, IRequestCreateSpecialtyIndication, IPatient } from '../pages/portal-pharmaceutical/schedule-indication/contracts';

async function consultPatientCRMPatientCare(body: IRequestConsultPatientCRMPatientCare): Promise<AxiosResponse<IPatient, any>> {
  const method = 'patients/ConsultPatientCRMPatientCare';

  return await authenticatedPostRequest(
    method,
    { ...body },
  );
}

async function createSpecialtyIndication(body: IRequestCreateSpecialtyIndication): Promise<void> {
  const method = 'patients/CreateSpecialtyIndication';
  const requestBody = {
    ...body
  };

  await authenticatedPostRequest(
    method,
    requestBody,
  );
}

export const patientsService = {
  consultPatientCRMPatientCare,
  createSpecialtyIndication,
};